module.exports = __webpack_public_path__ + "img/Enok.09376d4e.jpg";